<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" fullscreen transition="fade-transition" scrollable persistent max-width="600px")
      v-card
        v-card-title.px-5.primary
          v-row(no-gutters)
            v-col
              p.mb-0.title.white--text {{ $t('announcement') }}
            v-col.shrink
              v-btn.mr-n2(text icon @click="showModal = !showModal" height)
                v-icon(color="white" :size="24") mdi-close
        v-card-text.py-3
          p.title.font-weight-bold {{ announcement.title }}
          div(v-html="announcement.content")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ShowAnnouncement',
  props: ['open', 'announcement', 'company'],
  components: {  },
  data: () => ({
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    numbering () {
      return this.fetchCount*(this.page-1)
    }
  },
  watch: {
    showModal: {
      immediate: true,
      handler(val) {
        if (val) {
          this.markRead()
        }
      }
    },
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    markRead () {
      this.$axios.post(`/announcements/${this.announcement.id}/read/?company=${this.company.id}`)
      .then(() => {
        this.$emit('refresh')
      })
      .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "announcement": "Announcement"
  },
  "id": {
     "announcement": "Pengumuman"
  }
}
</i18n>
